import { Button, type ButtonProps, Spinner } from '@sjuni/ui';
import { useTranslation } from 'react-i18next';

/**
 * A submit button that cannot be pressed twice.
 *
 * `Button` has no busy state of its own — nothing on the public site submits
 * anything except the contact form. Every form in the dashboard does, so the
 * spinner, the disabled state and the `aria-busy` live here once rather than
 * being re-derived per screen.
 */
export interface SubmitButtonProps extends Omit<ButtonProps, 'type' | 'disabled'> {
  loading?: boolean;
  disabled?: boolean;
}

export function SubmitButton({ loading = false, disabled, children, ...props }: SubmitButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      {...props}
      type="submit"
      aria-busy={loading || undefined}
      disabled={loading || disabled}
      iconLeft={loading ? <Spinner size="sm" label={t('common.saving')} /> : props.iconLeft}
    >
      {children}
    </Button>
  );
}
